var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1247_6114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6466 1.75469C15.5549 1.41553 15.3758 1.10634 15.1274 0.857893C14.879 0.609445 14.5698 0.430413 14.2306 0.338625C12.989 0 7.99189 0 7.99189 0C7.99189 0 2.99451 0.01025 1.75289 0.348875C1.41373 0.440669 1.10454 0.61971 0.856102 0.868169C0.607665 1.11663 0.428651 1.42584 0.336887 1.765C-0.0386755 3.97113 -0.184363 7.33275 0.347199 9.45063C0.438973 9.78978 0.617991 10.099 0.866427 10.3474C1.11486 10.5959 1.42405 10.7749 1.7632 10.8667C3.00482 11.2053 8.00208 11.2053 8.00208 11.2053C8.00208 11.2053 12.9993 11.2053 14.2408 10.8667C14.58 10.7749 14.8892 10.5959 15.1376 10.3474C15.3861 10.099 15.5651 9.78979 15.6569 9.45063C16.053 7.24138 16.1751 3.88181 15.6466 1.75469Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39844 8.00342L10.5439 5.6023L6.39844 3.20117V8.00342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_6114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 11.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.1771c151efd629c6186177438ef9f107.svg";
export { ForwardRef as ReactComponent };